import React, { useState, useEffect } from "react";
import mahizhmathiLogo from "../assets/mahizhimathi-3.jpeg";

import mahendran from "../assets/mahendran.jpg";
import Premanand from "../assets/Premanand.jpg";
import Vivek from "../assets/Vivek.jpg";
import Sivaprakash from "../assets/Sivaprakash.jpg";
import SenthilKumar from "../assets/SenthilKumar.jpg";

import jewelleryImg from "../assets/mahizhimathi.png";
import infotechImg from "../assets/infotech.png";
import financeImg from "../assets/Finance.png";
import promotersImg from "../assets/prometers.png";
import agriImg from "../assets/Agri.png";
import importExportImg from "../assets/importExport.png";
import trustImg from "../assets/trust.png";
import educationImg from "../assets/Education.png";
import sportsImg from "../assets/sports.png";

import "../App.css";

export default function MahizhmathiRedesign() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);

  useEffect(() => {
    document.body.style.overflow = isModalOpen ? "hidden" : "auto";
  }, [isModalOpen]);

  const companiesdata = [
    {
      company: "Mahizhmathi Jewellery",
      summary:
        "Mahizhmathi Jewellery offers gold, silver, and diamond pieces blending tradition, elegance, and quality craftsmanship for everyday and bridal wear,",
      link: "https://mahizhmathi.com/",
      linkText: "Explore →",
      image: jewelleryImg,
      details: "We provide premium jewellery collections for weddings, festivals, and everyday wear with certified quality.",
      details1: " At Mahizhmathi, we take pride in creating a diverse collection of jewellery designed for men, women, and children, ensuring that every generation finds something truly special. From classic daily-wear pieces to statement designs for grand celebrations, our jewellery blends glamour, sophistication, and tradition with a modern touch.Complete Transparency and TrustLifetime Product Service."

    },
    {
      company: "Mahizhmathi Info Tech",
      summary:
        "Mahizhmathi Info Tech delivers innovative software solutions, digital transformation services, and custom IT development for businesses.",

      link: "",
      linkText: "Explore →",
      image: infotechImg,
      details: "Mahizhmathi InfoTech, We are part of the Mazhimathi Group, offers IT services centered on AI, automation, data science, aerospace tech, and robotics solutions. Consulting emphasizes strategic innovation, custom development, and ethical AI deployment for UK/US/Gulf Countries/India based clients. ",
      details1: "Mahizhmathi Information Technology (MIT) processes involve managing data and systems through core components like hardware, software, networks, and people, strategic functions (security, data storage) using structured workflows and automation for efficiency, ensuring information flows from raw data to actionable knowledge. "
      // "We provide web development, mobile apps, ERP solutions, cloud services, and enterprise tech support."
    },
    {
      company: "Mahizhmathi Nidhi & Finance",
      summary: "Mahizhmathi Nidhi & Finance provides secure, member-focused financial services including savings, deposits, and loans.",
      ink: "",
      linkText: "Explore →",
      image: financeImg,
      details: "Mahizhmathi Nidhi & Finance envisions transforming community savings into sustainable prosperity through secure, member-exclusive finance, seamlessly integrated with the Mazhimathi Group's AI-driven innovation for trusted growth in Tamil Nadu. ",
      details1: "Mahizhmathi Nidhi & Finance offers investors a stable, compliant entry into member-focused finance within the diversified Mazhimathi Group portfolio. These professional points highlight growth potential, regulatory strength, and synergy with IT/AI ventures for Indian economy. "
    },
    {
      company: "Mahizhmathi Promoters",
      summary: "Mahizhmathi Promoters specializes in real estate development, property promotion, and land investment solutions.",
      ink: "",
      linkText: "Explore →",
      image: promotersImg,
      details: "Mahizhmathi Promoters is a real estate division under the Mahizhmathi Group of Companies, focusing on property development, promotion, and land investments.",
      details1: "Mahizhmathi Promoters crafts dream homes with timeless vision and modern promise. Here are catchy promotional notes tailored for branding, drawing from the company's real estate,we are offering services in property development and investment opportunities within India."

    },
    {
      company: "Mahizhmathi Agri & Fertilizers",
      summary: "Mahizhmathi Agri & Fertilizers supports farmers with high-quality fertilizers and sustainable farming solutions.",
      ink: "",
      linkText: "Explore →",
      image: agriImg,
      details: "Mahizhmathi Agri & Fertilizers is a division of the Mahizhmathi Group of Companies, focused on supporting farmers in India with high-quality fertilizers and sustainable agricultural solutions.",
      details1: "Mahizhmathi Agri & Fertilizers offers a range of fertilizers and agro-products tailored for Indian farmers, focusing on soil health and crop yield improvement."

    },
    {
      company: "Mahizhmathi Import & Export",
      summary: "Mahizhmathi Import & Export manages global trade operations and international logistics.",
      ink: "",

      linkText: "Explore →",
      image: importExportImg,
      details: "Mahizhmathi Import & Export operates as a key division within the Mahizhmathi Group of Companies, specializing in international trade logistics.",
      details1: "Mahizhmathi Import & Export division manages import-export activities for agro-products, fertilizers, and other goods, supporting the group's agribusiness and multi-sector ventures in India.It facilitates cross-border shipments, customs clearance, and supply chain coordination."

    },
    {
      company: "Mahizhmathi Trust",
      summary: "Mahizhmathi Trust supports community welfare through education, healthcare, and upliftment programs.",
      link: "",

      linkText: "Explore →",
      image: trustImg,
      details: "Mahizhmathi Trust, as part of the Mazhimathi Group's community-focused initiatives from Coimbatore, likely channels charitable efforts into education for autism and handicapped children, healthcare, and community welfare programs; remaining initiatives focus on financial aid, cultural upliftment, and AI-enhanced social projects. ",
      details1: "Mahizhmathi Trust delivers education scholarships and vocational training for underprivileged youth, alongside healthcare support like medical camps for vulnerable families. Community welfare includes crisis relief, skill centres, financial aid for destitute families and orphans, and cultural upliftment to promote heritage and national integration. "

    },
    {
      company: "Mahizhmathi Educational Institutions",
      summary: "Mahizhmathi Educational Institutions provide quality education with modern learning environments.",
      link: "",
      linkText: "Explore →",
      image: educationImg,
      details: "Mahizhmathi Educational Institutions, part of the Mazhimathi Group's commitment to skillbuilding in Coimbatore, focus on tech-driven learning aligned with your AI and automation expertise. These initiatives bridge education with group ventures like InfoTech and Nidhi finance for holistic community development. ",
      details1: "Mahizhmathi Educational Institutions empower youth with latest edge cutting technology skills through the Mazhimathi Group's innovative learning eco-system."


    },
    {
      company: "Mahizhmathi Sports Academy",
      summary: "Mahizhmathi Sports Academy trains aspiring athletes with expert coaching and modern sports facilities.",
      ink: "",
      linkText: "Explore →",
      image: sportsImg,
      details: "Mahizhmathi Sports Academy, a Mazhimathi Group initiative from Coimbatore, nurtures young talent in swimming, athletics, and team sports to build discipline and community pride alongside IT and education ventures.",
      details1: "Mahizhmathi Sports Academy offers elite training in swimming, athletics, fitness, and team sports for youth, fostering discipline and excellence within the Mazhimathi Group's holistic development ecosystem. "

    }
  ];

  const handleExploreClick = (company) => {
    setSelectedCompany(company);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCompany(null);
  };

  return (
    <div className="bg-white text-black font-sans overflow-x-hidden relative">

      {/* NAVBAR */}
      <nav className="fixed top-0 left-0 w-full bg-[#0A1A44]/95 backdrop-blur-lg border-b border-blue-900/40 shadow-lg z-[999]">
        <div className="max-w-screen-xl mx-auto flex justify-between items-center px-6 py-4">

          <a href="#">
            <img src={mahizhmathiLogo} className="h-14 rounded-full border-2 shadow-lg" />
          </a>

          <div className="hidden md:flex gap-10 text-lg font-medium text-white">
            <a href="#" className="hover:text-blue-300 transition">Home</a>
            <a href="#about" className="hover:text-blue-300 transition">About MD</a>
            <a href="#about-us" className="hover:text-blue-300">About US</a>
            <a href="#teams" className="hover:text-blue-300 transition">Our Teams</a>
            <a href="#contact" className="hover:text-blue-300 transition">Contact Us</a>

          </div>

          <button onClick={() => setMenuOpen(!menuOpen)} className="md:hidden p-2 text-white">
            {menuOpen ? (
              <svg className="w-7 h-7" fill="none" stroke="currentColor">
                <path d="M6 18L18 6M6 6l12 12" strokeWidth="2" strokeLinecap="round" />
              </svg>
            ) : (
              <svg className="w-7 h-7" fill="none" stroke="currentColor">
                <path d="M4 6h16M4 12h16M4 18h16" strokeWidth="2" strokeLinecap="round" />
              </svg>
            )}
          </button>
        </div>

        <div className={`md:hidden transition-all duration-300 ${menuOpen ? "max-h-60 opacity-100" : "max-h-0 opacity-0"} overflow-hidden bg-[#0A1A44] text-white border-t border-blue-900/40`}>
          <div className="flex flex-col text-center py-4 space-y-4 text-lg font-semibold">
            <a onClick={() => setMenuOpen(false)} href="#" className="hover:text-blue-300">Home</a>
            <a onClick={() => setMenuOpen(false)} href="#about" className="hover:text-blue-300">About MD</a>
            <a onClick={() => setMenuOpen(false)} href="#about-us" className="hover:text-blue-300">About US</a>
            <a onClick={() => setMenuOpen(false)} href="#teams" className="hover:text-blue-300 transition">Our Teams</a>
            <a onClick={() => setMenuOpen(false)} href="#contact" className="hover:text-blue-300">Contact</a>
          
          
          </div>
        </div>
      </nav>

      <div className="pt-24"></div>

      {/* GROUP COMPANIES */}
      <section id="group" className="py-10 px-6 md:px-16 bg-white">

        <h2 className="text-center text-4xl md:text-5xl font-extrabold text-[#0A1A44] mb-16">
          Mahizhmathi Group Of Companies
        </h2>




        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-7xl mx-auto">
          {companiesdata.map((company, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl overflow-hidden shadow-xl border hover:shadow-2xl transition"
            >
              <div className="bg-[#0A1A44] p-5">
                <h3 className="text-lg font-bold text-white">
                  {company.company}
                </h3>
              </div>

              <div className="p-6">
                <p className="text-gray-700 mb-4">{company.summary}</p>
                <span
                  className="text-[#0A1A44] font-semibold hover:underline cursor-pointer"
                  onClick={() => handleExploreClick(company)}
                >
                  {company.linkText}
                </span>
              </div>
            </div>
          ))}
        </div>




        {isModalOpen && selectedCompany && (
          <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center p-4 z-[9999]">
            <div className="w-[90%] h-auto md:w-[70%] md:h-auto max-h-[90%] bg-white rounded-none md:rounded-2xl shadow-2xl p-6 md:p-10 overflow-y-auto relative">

              <button
                onClick={closeModal}
                className="absolute top-4 right-5 text-gray-600 hover:text-black text-3xl font-bold"
              >
                &times;
              </button>

              <div className="flex flex-col md:flex-row gap-10">

                <div className="w-full md:w-1/2 h-full">
                  <img
                    src={selectedCompany.image}
                    alt={selectedCompany.company}
                    className="w-full h-full object-cover rounded-xl shadow-lg"
                  />
                </div>


                <div className="w-full md:w-1/2">
                  <h3 className="text-3xl font-extrabold text-[#0A1A44] mb-4">
                    {selectedCompany.company}
                  </h3>


                  <p className="text-gray-600 text-md leading-relaxed">
                    {selectedCompany.details}
                  </p>
                  <p className="text-gray-600 text-md leading-relaxed mt-5">
                    {selectedCompany.details1}
                  </p>

                  {selectedCompany.link && (
                    <a
                      href={selectedCompany.link}
                      target="_blank"
                      className="inline-block mt-6 bg-[#0A1A44] text-white px-6 py-3 rounded-xl hover:bg-blue-900 transition"
                    >
                      Visit Website
                    </a>
                  )}


                </div>

              </div>
            </div>
          </div>
        )}

      </section>


      <section id="about" className="px-6 md:px-16 py-24 bg-gray-50">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <img
            src={mahendran}
            alt="mahendran"
            className="w-full rounded-3xl shadow-2xl object-cover hover:scale-105 transition border-4 border-blue-900/40"
          />

          <div className="space-y-6">
            <h2 className="text-2xl md:text-2xl font-extrabold text-[#0A1A44] leading-snug uppercase">
              Managing Director – Mr. Mahendiran
            </h2>

            <p className="text-gray-700 text-lg leading-relaxed">

              Mr. Mahendiran, the Managing Director of the Mahizhmathi Group of Companies, is a dynamic entrepreneur who has built a diverse ecosystem of businesses with a clear mission: to empower communities, create sustainable opportunities, and deliver excellence across every sector we serve.
              Under his leadership, the Mahizhmathi Group has grown into a multi-industry network covering IT, finance, real estate, agriculture, sports, education, charity, and global trade.
            </p>

            <h2 className="text-2xl md:text-2xl font-extrabold text-[#0A1A44] leading-snug uppercase">
              MANAGING DIRECTOR’S VISION STATEMENT

            </h2>

            <p className="text-gray-700 text-lg leading-relaxed">
              “My vision is to build the Mahizhmathi Group as a trusted name across industries — a group that creates value, supports communities, and provides opportunities for every individual connected with us. Our goal is not just business growth, but meaningful impact.”

            </p>






            <h2 className="text-2xl md:text-2xl font-extrabold text-[#0A1A44] leading-snug uppercase">
              MESSAGE FROM THE MANAGING DIRECTOR


            </h2>

            <p className="text-gray-700 text-lg leading-relaxed">
              “At the Mahizhmathi Group, we believe in hard work, discipline, and a commitment to doing the right thing.
              Every company under our brand is built to serve people — whether it is through technology, finance, agriculture, sports, education, or social welfare.
              Our mission is simple: Serve with trust. Grow with purpose. Lead with integrity.”

            </p>
          </div>



        </div>
      </section>


      {/* TEAMS */}
      <section id="teams" className="py-20 bg-white">
        <h2 className="text-center text-4xl font-extrabold text-[#0A1A44] mb-12">
          Our Partners
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12 max-w-7xl mx-auto px-6">
          {[
            { img: SenthilKumar, name: "SenthilKumar", role: "Chief Operating Officer (COO)" },
            { img: Sivaprakash, name: "Sivaprakash", role: "Chief Financial Officer (CFO)" },
            { img: Vivek, name: "Vivek", role: "Chief Administrative Officer (CAO)" },
            { img: Premanand, name: "Premanand", role: "Chief Executive Officer (CEO)" }
          ].map((p, i) => (
            <div key={i} className="flex flex-col items-center">
              <div className="w-full md:h-80 rounded-xl overflow-hidden shadow-lg">
                <img src={p.img} className="w-full h-full object-cover" />
              </div>
              <h3 className="text-xl font-bold text-[#0A1A44] mt-4">{p.name}</h3>
              <p className="text-md font-bold text-gray-600">{p.role}</p>
            </div>
          ))}
        </div>
      </section>



<div className="bg-gray-50 py-24 px-6 md:px-16">
  <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-start">

    <section
      id="contact"
      className="bg-white rounded-2xl shadow-lg p-10  text-left"
    >
      <h2 className="text-4xl font-extrabold text-[#0A1A44] mb-4">
        Contact Us
      </h2>

      <p className="text-gray-600 text-lg mb-8">
        Reach out for business or corporate inquiries.
      </p>

      <div className="space-y-4 text-gray-700 text-lg">
        <p className="text-[#0A1A44] font-bold text-xl">
          Mahizhmathi Group HQ
        </p>

        <p>3/251 – Yoga Towers, Perumanallur</p>
        <p>Tiruppur – 641666, Tamil Nadu, India</p>

        <div className="pt-4 space-y-8">
          <p className="flex items-center gap-2">
            {/* 📞 <span>+91 93848 19434</span> */}
          </p>
          <p className="flex items-center gap-2 ">
            {/* 📞 <span>+91 93848 19435</span> */}
          </p>  <p className="flex items-center gap-2">
            📞 <span>+91 93848 19437</span>
          </p>
          {/* <p className="flex items-center gap-2">
            ✉️ <span>mahizhmathigroupofcompanies@gmail.com</span>
          </p> */}
        </div>
      </div>
    </section>

    <section
      id="about-us"
      className="bg-white rounded-2xl shadow-lg p-10 text-left"
    >
      <h2 className="text-4xl font-extrabold text-[#0A1A44] mb-6">
        About Us
      </h2>

      <p className="text-gray-700 text-lg leading-relaxed space-y-4">
        <span className="block">
          Mahizhmathi Group of Companies is a technology-driven investment and
          venture-building group focused on creating scalable, future-ready
          businesses.
        </span>

        <span className="block">
          We identify high-potential ideas and transform them into structured,
          market-ready enterprises through technology, data, and strategic
          execution.
        </span>

        <span className="block">
          Our approach combines early-stage capital with deep operational
          involvement, ensuring innovation translates into commercial success.
        </span>

        {/* <span className="block">
          We actively build and invest in ventures across technology, AI-enabled
          services, fintech, agri-innovation, education, and emerging industries.
        </span> */}

      

     

      

    

      </p>
    </section>

  </div>
</div>







      {/* <div className="flex flex-row">
        <section id="contact" className="bg-white py-24 px-6 md:px-16 text-center">
          <h2 className="text-4xl font-extrabold text-[#0A1A44] mb-6">Contact Us</h2>

          <p className="text-gray-700 text-lg">
            Reach out for business or corporate inquiries.
          </p>

          <div className="mt-10 text-gray-700 text-lg">
            <p className="text-[#0A1A44] font-bold text-xl">Mahizhmathi Group HQ</p>
            <p>3/251 - Yoga Towers, Perumanallur</p>
            <p>Tiruppur - 641666, Tamil Nadu, India</p>
            <p className="pt-3">📞 +91 93848 19434</p>
            <p>📞 +91 93848 19435</p>
            <p>✉️ mahizhmathigroupofcompanies@gmail.com</p>
          </div>
        </section>


        <section id="about-us">
          <p>Mahizhmathi Group of Companies is a technology-driven investment and venture-building group focused on creating scalable, future-ready businesses.
            We identify high-potential ideas and transform them into structured, market-ready enterprises through technology, data, and strategic execution.
            Our approach combines early-stage capital with deep operational involvement, ensuring innovation translates into commercial success.
            We actively build and invest in ventures across technology, AI-enabled services, fintech, agri-innovation, education, and emerging industries.
            Mahizhmathi Group operates as a hands-on partner, supporting product development, system design, governance, and market expansion.
            Every portfolio company is driven by strong fundamentals, modern technology stacks, and scalable business models.
            We emphasize long-term value creation, ethical governance, and sustainable growth.
            By aligning innovation with disciplined execution, we enable businesses to move from concept to impact.
            Mahizhmathi Group stands for technology leadership, strategic investment, and business excellence.</p>
        </section>
      </div> */}




      <footer className="bg-[#0A1A44] py-6 text-center text-white">
        © {new Date().getFullYear()} Mahizhmathi Group. All Rights Reserved.
      </footer>

    </div>
  );
}
